import {createContext} from 'react'
import {DEVICE_TYPES} from '../utils'

export const initialAppContext = {
  multilanguage: false,
  availableLanguages: [],
  hasReorder: false,
  bonuspointsAvailable: true,
  reorderLink: '/account/orders/reorder',
  helpLink: '',
  translations: new Map(),
  showSearch: true,
  showCategories: true,
  categories: [],
  showCart: true,
  exorbyteId: '',
  exorbytePathKey: '',
  exorbyteProxyUrl: '',
  bundle: 'zooplus',
  brand: 'zooplus',
  mediaServerUrl: '',
  device: DEVICE_TYPES.DESKTOP,
  clientWidth: 0,
  isBurgerNavOpen: false,
  cart: null,
  isSearchFlyoutOpen: false,
  toggleBurgerNav: () => {},
  setBurgerNavOpen: () => {},
  setSearchFlyoutOpen: () => {},
  shippingFeeURL: '',
  securityIconsURL: '',
  cartURL: '',
  viaWebC: true
}
const AppContext = createContext(initialAppContext);

export default AppContext;
